// Tracks whether the app's assets are stale (e.g. after a deploy).
// Instead of reloading immediately, we set this flag and let the
// next user-initiated navigation do a hard reload — so it feels
// like a normal page transition rather than a random refresh.

let stale = false;
let listeners: Array<() => void> = [];

// The server's build revision, learned from the X-Vcs-Revision header
// on every GraphQL response. When it changes mid-session, the app is stale.
let serverRevision: string | null = null;

export function markStale() {
  if (stale) return;
  stale = true;
  listeners.forEach((fn) => fn());
}

export function isStale() {
  return stale;
}

/**
 * Called by the Apollo Link on every GraphQL response.
 * Compares the server's current revision against the one seen on first request.
 * A mismatch means the backend was redeployed → assets are stale.
 */
export function checkRevision(revision: string) {
  if (!revision) return;
  if (!serverRevision) {
    serverRevision = revision;
    return;
  }
  if (revision !== serverRevision) {
    markStale();
  }
}

// Expose on window for manual testing: __markStale() in the browser console
if (import.meta.env.DEV) {
  (window as never as Record<string, unknown>).__markStale = markStale;
}

export function onStale(fn: () => void) {
  if (stale) {
    fn();
    return () => {};
  }
  listeners.push(fn);
  return () => {
    listeners = listeners.filter((l) => l !== fn);
  };
}
